import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode"; 

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const [authToken, setAuthToken] = useState("");
  const [decodedToken, setDecodedToken] = useState(null);

  useEffect(() => {
    const token = Cookies.get("token");
    const decodedToken = Cookies.get("decodedToken");


    if (token) {
      try {
        const decoded = jwtDecode(token); 
        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp && decoded.exp < currentTime) {
          logout();
          return;
        }
      } catch (err) {
        logout();
        return;
      }
    }

    if (token && decodedToken) {
      setIsAuthenticated(true);
      setAuthToken(token);
      setDecodedToken(JSON.parse(decodedToken));
    } else {
      setIsAuthenticated(false);
      setAuthToken(null);
      setDecodedToken(null);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token); 
          const currentTime = Math.floor(Date.now() / 1000);
          if (decoded.exp && decoded.exp < currentTime) {
            logout();
          }
        } catch {
          logout();
        }
      }
    }, 5 * 60 * 1000); // Every 5 minutes

    return () => clearInterval(interval);
  }, []);

  const login = (token, decodedToken) => {
    setIsAuthenticated(true);
    setAuthToken(token);
    setDecodedToken(decodedToken);
    Cookies.set("token", token, { expires: 7, secure: true }); // Expires in 7 day
    Cookies.set("decodedToken", JSON.stringify(decodedToken), {
      expires: 7,
      secure: true, // Secure cookies are only sent over HTTPS
    });
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("customerId");
    localStorage.removeItem("decode");
    localStorage.removeItem("login-from");
    localStorage.removeItem("expirationTime");
    localStorage.removeItem("orderDetails");
    localStorage.removeItem("orderReportDetails");
    localStorage.removeItem("_grecaptcha");
    setAuthToken("");
    setDecodedToken(null);
    Cookies.remove("token");
    Cookies.remove("decodedToken");

    // Cookies.remove("selectedAddress");
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        login,
        logout,
        authToken,
        decodedToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
